import { type LoaderFunctionArgs, redirect } from "react-router-dom";

import { completeSignIn, isSignedIn, signIn } from "@/api/auth";

const waitForRedirect = () => new Promise<never>(() => {});

export const requireSignIn = async ({ request }: LoaderFunctionArgs) => {
    if (await isSignedIn()) {
        return null;
    }
    const { pathname, search } = new URL(request.url);
    await signIn(`${pathname}${search}`);
    return waitForRedirect();
};

export const finishSignIn = async () => redirect(await completeSignIn());
